module.exports = __webpack_public_path__ + "media/images/icon_list/share_icon_x-f5a493ce4496c3c9f990b197bb855ae6.svg";